<template>
  <b-list-group flush>
    <b-list-group-item
      v-for="u in udata"
      :key="u.personalId"
    >
      <PersonData
        :person="u"
        :is-read-only="ReadOnly"
        :IsDeleteAble="IsDeleteAble"
        :MinLengthOne="MinLengthOne"
        :AllowDelete="AllowDelete"
        @handle-deleted="onDeletedBtnClicked"
        @handle-edit="onEditBtnClicked"
      />

    </b-list-group-item>
  </b-list-group>
</template>

<script>
import {
  BFormGroup, BRow, BCol, BFormInput, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import PersonData from './PersonData.vue'

export default {
  components: {
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
    PersonData,
  },
  props: {
    data: {
      type: Array,
      required: true,

    },
    ReadOnly: String,
    MinLengthOne : true,
    AllowDelete : true,
    // IsReadOnlyA: String,
  },
  setup(props) {
    return {
      udata: props.data,
      // ReadOnly: props.IsReadOnly,//ใช้ไม่ได้
    }
  },
  methods: {
    onDeletedBtnClicked(id) {
      this.$emit('handle-delete-personal', id)
    },
    onEditBtnClicked(id) {
      this.$emit('handle-edit-personal', id)
    },
  },
  computed: {
    IsDeleteAble: function () {
      //console.log('this.MinLengthOne', this.MinLengthOne)
      if (this.MinLengthOne === false) return true
      return this.udata.length <= 1 ? false : true
    }
}
}
</script>

<style>

</style>
